export default __webpack_public_path__ + "static/media/e.6f54bd89.png";